import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

// local config files
import portalConfig from '../../assets/portal-config.json';
import portalModelView from '../../assets/portal-model-view.json';

@Injectable()
export class BackendInterceptor implements HttpInterceptor {

  private _urlMap: { [key: string] : any } = {
    "assets/portal-config.json": portalConfig,
    "nxi/welcome?isMfe=true&isModern=true&needJsonData=true": portalModelView
};



  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    console.log("BE Interceptor ", request.url);

    if (request.method === "GET" && environment.environmentName === "local" && request.url in this._urlMap)
        return of(new HttpResponse({ status: 200, body: this._urlMap[request.url]}));

    // handle all non-local cases
    const newRequest = request.clone( {
      url: environment.apiUrl + request.url
    })
    return next.handle(newRequest);
  }
}
